import { Avatar, Button, Form, Input, message, Modal, Space } from "antd";
import { Rule } from "antd/lib/form";
import { useForm } from "antd/lib/form/Form";
import FormItem from "antd/lib/form/FormItem";
import { shopApi } from "api/shop.api";
import React, { useEffect, useState } from "react";
import { ModalStatus } from "types/modal";
import { Shop } from "types/shop";
const rules: Rule[] = [{ required: true }];

export const VerifyModal = ({
  visible,
  selectedShop,
  onClose,
  onSubmitOk,
}: {
  visible: boolean;
  selectedShop?: Partial<Shop>;
  onClose: () => void;
  onSubmitOk: () => void;
}) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmitForm = async () => {
    await form.validateFields();
    setLoading(true);
    const dataPost = form.getFieldsValue();
    try {
      await shopApi.checkUsername({ username: dataPost.username });
    } catch (error) {
      return setLoading(false);
    }

    try {
      if (selectedShop?.workshops) {
        await shopApi.approve(selectedShop?.id || 0, {
          ...dataPost,
          name: selectedShop?.workshops[0]?.name,
          phone: selectedShop?.workshops[0]?.phone,
        });
      }

      onSubmitOk();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    (<Modal
      onCancel={onClose}
      open={visible}
      title={"Tạo mật khẩu"}
      confirmLoading={loading}
      onOk={handleSubmitForm}
    >
      <Form form={form} layout="vertical">
        <FormItem rules={rules} required label="Username" name={"username"}>
          <Input />
        </FormItem>
        <FormItem rules={rules} required label="Mật khẩu" name={"password"}>
          <Input />
        </FormItem>
      </Form>
    </Modal>)
  );
};
